import { Link } from "@mui/material";

import {
  FAQS,
  FooterLinks,
  NavSubmenuLinks,
  REGISTRATION_CARDS,
  TERMS_AND_CONDITION,
} from "./helper";
import { routes } from "src/shared/routes";
import { constants } from "src/shared/constants";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";

import LogoImage from "public/images/stlouiscardinals/logo.png";
import BackgroundImage from "public/images/stlouiscardinals/venue.jpg";

export const stlouiscardinals_themeupgrades_sandbox: TTeamConfig = {
  TEAM_SCHEMA: "stlouiscardinals_themeupgrades_sandbox",
  TEAM_FULL_NAME: "St. Louis Cardinals",
  BROWSER_TITLE: "Cardinals Theme Night Upgrades",
  CLIENT_ID: "XATXJLZGaKgqGHjcRraofrbPdAfiGn8e",
  VENDOR: constants.vendorUUIDs.ticketsdotcom,

  TEAM_GLOBAL_SETTINGS: {
    COLORS_PRIMARY: "#C41E3A",
    COLORS_SECONDARY: "#0C2340",
    IS_INTERCOM_ENABLED: true,
    IS_BALLPARK_APP: true,
    NAV_MENU: {
      HIDE_AUTH_BUTTONS: true,
      HIDE_EARN_REWARDS: true,
      HIDE_UPCOMING_EVENTS: true,
      LOGIN_LABEL: "View Upgrades",
      HIDE_MANAGE_SUBSCRIPTION: true,
      ADDITIONAL_SUB_MENU_ITEMS: NavSubmenuLinks,
    },
    DEFAULT_APP_ROUTE: routes.landing,
    DISABLE_PASS_ON_ACCOUNT_RESTRICTION: true,
    DISABLE_SIT_WITH_FRIENDS: true,
    FOOTER: {
      LINKS: FooterLinks,
      COPYRIGHT_TEXT: `${new Date().getFullYear()} ©`,
    },
  },

  LANDING_PAGE_SETTINGS: {
    REGISTRATION_CARD_SETTINGS: {
      DISPLAY_ABOVE_STATIC_BANNER: true,
      HIDE_SECTION_TITLE: true,
      REGISTRATION_CARDS,
    },
    HIDE_PASSES: true,

    STATIC_BANNER: {
      IS_ENABLED: true,
    },
  },

  GROUP_INVITE_PAGE_SETTINGS: {
    PASS_BANNER: {
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      PASS_DISPLAY_MODE: "separate",
    },
  },

  CHECKOUT_PAGE_SETTINGS: {
    CHECKOUT_FORM: {
      SAVE_CARD_SWITCH_ENABLED: false,
      DISABLE_SAVE_CARD: true,
    },

    HIDE_ADD_ON_SERVICE_FEE: true,

    /** add service fee to add on price - add on cart item only (not total) */
    ADD_SERVICE_FEE_TO_PRICE: true,
  },

  HOME_PAGE_SETTINGS: {
    EVENT_BANNER: {
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
    },

    EVENT_CARD: {
      ADD_ON_DISPLAY_MODE: "list",
      ATTEND_BUTTON_COLOR: "#FEDB00",
      HIDE_NEXT_GAME: true,
      HIDE_EVENT_LOGO: true,
    },
    ADD_ON: {
      ADD_SERVICE_FEE_TO_PRICE: true,
      ADD_ON_PURCHASE_SUCCESS_MESSAGE: {
        TITLE: () => "Purchase Confirmed!",
        DESCRIPTION: () => (
          <>
            Thank you for your Theme Night purchase! Your item is now available
            to be picked up at the Budweiser Terrace Theme Tickets kiosk, across
            from Section 431. Your theme ticket to present at the kiosk is
            available in Ballpark App{" "}
            <Link
              href="https://bp.mlb.com/Wallet"
              sx={{
                color: "white",
                cursor: "pointer",
                textDecoration: "underline",
              }}
            >
              here
            </Link>
            .
          </>
        ),
      },
    },
  },

  IMAGES: {
    LOGO_URL: LogoImage.src,
    ORDER_SUMMERY_BACKGROUND_URL: BackgroundImage.src,
    LANDING_PAGE_STATIC_BANNER_URL: BackgroundImage.src,
    GROUP_INVITE_PAGE_STATIC_BANNER_URL: BackgroundImage.src,
  },

  LANGUAGES: {
    FAQS,
    TERMS_AND_CONDITION,
  },
};
